import {
  FileUploadFormField,
  BFFGroupAccount,
  NonFileUploadFormField,
} from '@la/types';

export type RegistrantState = {
  eSignature?: string;
  existingRegistrationError: string;
  fileUploadFormFields: Record<number, FileUploadFormField>;
  groupAccount: BFFGroupAccount | null;
  nonFileUploadFormFields: Record<number, NonFileUploadFormField>;
  signedWaivers: Record<string, boolean>;
  selectedPlayer: string;
};

export type RegistrantStateActions =
  | {
      type: 'SET_NON_FILE_UPLOAD_FORM_FIELD';
      payload: {
        id: number;
        field: NonFileUploadFormField;
      };
    }
  | {
      type: 'SET_FILE_UPLOAD_FORM_FIELD';
      payload: {
        id: number;
        field: FileUploadFormField;
      };
    }
  | { type: 'SET_GROUP_ACCOUNT'; payload: BFFGroupAccount | null }
  | {
      type: 'SET_GROUP_ACCOUNT_AND_SELECTED_PLAYER';
      payload: BFFGroupAccount | null;
    }
  | {
      type: 'SET_SIGNED_WAIVERS';
      payload: {
        id: string;
        signed?: boolean;
      };
    }
  | {
      type: 'SET_E_SIGNATURE';
      payload?: string;
    }
  | { type: 'SET_SELECTED_PLAYER'; payload: string }
  | { type: 'SET_EXISTING_REGISTRATION_ERROR'; payload: string };

export const registrantInitialState: RegistrantState = {
  eSignature: undefined,
  nonFileUploadFormFields: {},
  fileUploadFormFields: {},
  groupAccount: null,
  signedWaivers: {},
  selectedPlayer: '',
  existingRegistrationError: '',
};

export function registrantReducer(
  state = registrantInitialState,
  action: RegistrantStateActions
): RegistrantState {
  switch (action.type) {
    case 'SET_NON_FILE_UPLOAD_FORM_FIELD': {
      return {
        ...state,
        nonFileUploadFormFields: {
          ...state.nonFileUploadFormFields,
          [action.payload.id]: action.payload.field,
        },
      };
    }
    case 'SET_FILE_UPLOAD_FORM_FIELD': {
      return {
        ...state,
        fileUploadFormFields: {
          ...state.fileUploadFormFields,
          [action.payload.id]: action.payload.field,
        },
      };
    }
    case 'SET_GROUP_ACCOUNT': {
      return {
        ...state,
        groupAccount: action.payload,
      };
    }
    case 'SET_GROUP_ACCOUNT_AND_SELECTED_PLAYER': {
      const groupAccount = action.payload;
      const members = groupAccount?.members;

      // The last member is the array is the most recently added
      const lastMemberId = members
        ? members[members.length - 1].user.id.toString()
        : '';

      return {
        ...state,
        groupAccount: action.payload,
        selectedPlayer: lastMemberId,
      };
    }
    case 'SET_SIGNED_WAIVERS': {
      const { id, signed } = action.payload;
      return {
        ...state,
        signedWaivers: {
          ...state.signedWaivers,
          [id]: signed === undefined ? !state.signedWaivers[id] : signed,
        },
      };
    }
    case 'SET_E_SIGNATURE': {
      return {
        ...state,
        eSignature: action.payload,
      };
    }

    case 'SET_SELECTED_PLAYER':
      return {
        ...state,
        selectedPlayer: action.payload,
      };

    case 'SET_EXISTING_REGISTRATION_ERROR':
      return {
        ...state,
        existingRegistrationError: action.payload,
      };
    default:
      throw new Error('Invalid action');
  }
}
